import httpUtils from '../../utils/HttpUtils'

class CustomerPayVoucherService {

  //保存业主支付凭证
  async save (customerPayVoucher) {
    var result = null;
    try {
      result = await httpUtils.post('/customer/payVoucher/save',customerPayVoucher);
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //查询业主支付凭证
  async newest (projectId = '') {
    var result = null;
    try {
      result = await httpUtils.post('/customer/payVoucher/newest',{projectId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

}
export default new CustomerPayVoucherService()
